import collect from 'collect.js';

export default class GdConfig {

  constructor(theme, text) {
    this.theme = theme;
    this.text = text;
  }

  color() {
    if (this.theme.color) {
      return this.theme.color;
    }
    return [];
  }

  defaultColors() {
    if (this.theme.extra) {
      return collect(this.theme.extra)
        .filter((value, key) => value && ['text-link-color'].indexOf(key) > -1)
        .all()
    }
    return [];
  }

  defaultLinkColor() {
    const first = collect(this.defaultColors()).filter((value, key) => key === 'text-link-color').first();
    if (first) {
      return `.v-application a { color: ${first}; }`;
    }

    return null;
  }

  getDefaultColorRules() {
    return collect([
      this.defaultLinkColor()
    ])
      .filter()
      .all()
  }

  extraColors() {
    if (this.theme.extra) {
      return collect(this.theme.extra).filter().all();
    }

    return [];
  }

  getThemeImages(key = null) {
    if (this.theme.images && !key) {
      return this.theme.images;
    }
    if (this.theme.images && key) {
      return this.theme.images[key];
    }

    return null;
  }


  getText(key = null) {
    if (this.text && !key) {
      return this.text;
    }
    if (this.text && key) {
      return this.text[key];
    }

    return null;
  }
}
